const single = 8;

export default {
  single,
  double: single * 2,
  half: single * 0.5,
  triple: single * 3,
  quad: single * 4,
};
